export enum ChangeUpdateApplicantsTypes {
  FETCH_CHANGE_UPDATE_APPLICANTS_SUCCESS = "FETCH_CHANGE_UPDATE_APPLICANTS_SUCCESS",
  FETCH_CHANGE_UPDATE_APPLICANTS_FAILURE = "FETCH_CHANGE_UPDATE_APPLICANTS_FAILURE",
  FETCH_CHANGE_UPDATE_APPLICANTS_REQUEST = "FETCH_CHANGE_UPDATE_APPLICANTS_REQUEST"
}